"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var effects_1 = require("@ngrx/effects");
var store_1 = require("@ngrx/store");
var skynet_store_languages_api_1 = require("@synisys/skynet-store-languages-api");
var skynet_store_properties_api_1 = require("@synisys/skynet-store-properties-api");
var lodash_decorators_1 = require("lodash-decorators");
var skynet_store_adapter_service_1 = require("./skynet-store-adapter.service");
var skynet_store_module_1 = require("./skynet-store.module");
var SkynetStoreAdapterModule = /** @class */ (function () {
    function SkynetStoreAdapterModule(skynetStoreAdapterService, // for init
    store) {
        this.skynetStoreAdapterService = skynetStoreAdapterService;
        this.store = store;
        this.init();
    }
    SkynetStoreAdapterModule_1 = SkynetStoreAdapterModule;
    SkynetStoreAdapterModule.forRoot = function () {
        if (SkynetStoreAdapterModule_1._imported) {
            throw Error('SkynetStoreAdapterModule already imported');
        }
        SkynetStoreAdapterModule_1._imported = true;
        return SkynetStoreAdapterModule_1;
    };
    SkynetStoreAdapterModule.prototype.init = function () {
        this.store.dispatch({ type: skynet_store_properties_api_1.PropertiesActionTypes.GetProperties });
        skynet_store_languages_api_1.languageStoreManager.selectAll(this.store);
    };
    SkynetStoreAdapterModule._imported = false;
    __decorate([
        lodash_decorators_1.Memoize(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SkynetStoreAdapterModule.prototype, "init", null);
    SkynetStoreAdapterModule = SkynetStoreAdapterModule_1 = __decorate([
        core_1.NgModule({
            exports: [effects_1.EffectsModule, store_1.StoreModule],
            imports: [skynet_store_module_1.SkynetStoreModule],
            providers: [skynet_store_adapter_service_1.SkynetStoreAdapterService],
        }),
        __metadata("design:paramtypes", [skynet_store_adapter_service_1.SkynetStoreAdapterService,
            store_1.Store])
    ], SkynetStoreAdapterModule);
    return SkynetStoreAdapterModule;
    var SkynetStoreAdapterModule_1;
}());
exports.SkynetStoreAdapterModule = SkynetStoreAdapterModule;
//# sourceMappingURL=skynet-store-adapter.module.js.map